module.exports = __webpack_public_path__ + "img/Louis-Image-02.1daf9fd7.jpg";